export const LOADER_SHOW = 'LOADER_SHOW'
export const LOADER_HIDE = 'LOADER_HIDE'
